export const initLightBox = () => {
    window.Lightbox = window.Lightbox || {};
    window.Lightbox.Checkout = (function () {
        var configure = {};

        function showLightbox() {
            if (this.configure) {
                var lightBoxDoamin = 'https://grey.paysky.io:9006/PayInterface';
                var paymentMethodFromLightBox = null;
                var mId = 0;
                var tId = 0;
                var orderId = "";
                var amount = 0;
                var MerchantReference = "";
                var configPath = window.Lightbox.Checkout.configure;

                if (typeof (configPath.paymentMethodFromLightBox) !== 'undefined') {
                    paymentMethodFromLightBox = configPath.paymentMethodFromLightBox;
                }

                if (typeof (configPath.OrderId) !== 'undefined' && configPath.OrderId !== null) {
                    orderId = configPath.OrderId;
                }

                if (typeof (configPath.MID) !== 'undefined' && configPath.MID !== null && !isNaN(configPath.MID)) {
                    mId = configPath.MID;
                }

                if (typeof (configPath.TID) !== 'undefined' && configPath.TID !== null && !isNaN(configPath.TID)) {
                    tId = configPath.TID;
                }

                if (typeof (configPath.AmountTrxn) !== 'undefined' && configPath.AmountTrxn !== null && !isNaN(configPath.AmountTrxn)) {
                    amount = configPath.AmountTrxn / 100;
                }

                if (typeof (configPath.MerchantReference) !== 'undefined') {
                    MerchantReference = configPath.MerchantReference;
                }

                var lightboxHostedQueryString = '/?';
                lightboxHostedQueryString += 'paymentMethodFromLightBox=' + paymentMethodFromLightBox + '&';
                lightboxHostedQueryString += 'OrderID=' + orderId + '&';
                lightboxHostedQueryString += 'MID=' + mId + '&';
                lightboxHostedQueryString += 'MerchantReference=' + MerchantReference + '&';
                lightboxHostedQueryString += 'amount=' + amount + '&';
                lightboxHostedQueryString += 'TID=' + tId;
                var urlsrc = lightBoxDoamin + '/Home/LightboxHostedCheckout' + lightboxHostedQueryString;


                var ifrm = document.createElement("iframe");
                ifrm.id = "Lightbox";
                ifrm.setAttribute("src", urlsrc);
                ifrm.style.zIndex = "999999";
                ifrm.style.display = "block";
                ifrm.style.backgroundColor = "transparent";
                ifrm.style.border = "0px none transparent";
                ifrm.style.overflowX = "hidden"; //hidden
                ifrm.style.overflowY = "auto"; //scroll//auto

                ifrm.style.visibility = "visible";
                ifrm.style.margin = "0px";
                ifrm.style.padding = "0px";
                ifrm.style.position = "fixed";
                ifrm.style.left = "0px";
                ifrm.style.top = "0px;"
                ifrm.style.bottom = "0px";
                ifrm.style.right = "0px";
                ifrm.style.width = "100%";
                ifrm.style.height = "100%";
                document.body.appendChild(ifrm);


                window.addEventListener('message', function (event) {
                    var parser = document.createElement('a');
                    parser.href = lightBoxDoamin;
                    if (event.origin === parser.origin) {
                        if (event.data != null && event.data != '') {

                            if (event.data.callback == 'errorCallback' && this.Lightbox.Checkout.configure.errorCallback !== undefined) {
                                this.Lightbox.Checkout.configure.errorCallback(event.data.error);
                            } else if (event.data.callback == 'completeCallback' && this.Lightbox.Checkout.configure.completeCallback !== undefined) {
                                this.Lightbox.Checkout.configure.completeCallback(event.data.paymentInfo);
                            } else if (event.data.callback == 'cancelCallback') {

                                closeLightbox();

                                if (this.Lightbox.Checkout.configure.cancelCallback !== undefined) {
                                    this.Lightbox.Checkout.configure.cancelCallback();
                                }
                            }
                        }
                    }
                }, false);

            } else {
                console.log('no configuration');
            }
        };

        function closeLightbox() {

            var elem = document.getElementById('Lightbox');
            if (elem != null && elem.parentNode != null) {
                elem.parentNode.removeChild(elem);
            }
        };

        // Public interface
        return {
            showLightbox: showLightbox,
            closeLightbox: closeLightbox,
            configure: configure
        };

    })();
}

// TEST
const MERCHANT_ID = '51584';
const TERMINAL_ID = "85621355";


// const MERCHANT_ID = '10293821840';
// const TERMINAL_ID = "39374979";
export const callLightBox = (amount = 255.0, m_ref = "000000", callback, error, cancel = () => {}) => {
    let merchantId = MERCHANT_ID;
    let terminalId = TERMINAL_ID;
    amount = amount * 100;
    window.Lightbox.Checkout.configure = {
        MID: merchantId,
        TID: terminalId,
        AmountTrxn: amount,
        MerchantReference: m_ref,
        paymentMethodFromLightBox: 0,
        completeCallback: function (data) {
            console.log('completed');
            callback(data);
            // store transaction

            // redirect user to upcoming res

            /*$('#resultTitle').css('visibility', 'visible');
            $('#successResult').css('display', 'block');
            $('#paymentInfoTable').html('<td>' + data.TxnDate + '</td>' +
                '<td>' + data.SystemReference + '</td>' +
                '<td>' + data.NetworkReference + '</td>' +
                '<td>' + data.MerchantReference + '</td>' +
                '<td>' + data.Amount + '</td>' +
                '<td>' + data.Currency + '</td>' +
                '<td>' + data.PaidThrough + '</td>' +
                '<td>' + data.PayerAccount + '</td>' +
                '<td>' + data.PayerName + '</td>' +
                '<td>' + data.ProviderSchemeName + '</td>');*/
            console.log(data);
        },
        errorCallback: function () {
            console.log('error');
            error();
        },
        cancelCallback: function () {
            console.log('cancel');
            cancel();
        }
    };

    window.Lightbox.Checkout.showLightbox();
};


